// /assets/scripts/components/micromodal.js
import MicroModal from './modal/micromodal.es.js';
import { EventBus } from '../events/event-bus.js';

export const micromodal = {
  selector: '.v-component--micromodal',
  reactive: true,

  run(el) {
    const modalId = el.dataset.modalId;
    if (!modalId) {
      console.warn('Missing data-modal-id on modal:', el);
      return;
    }

    if (!window.__micromodalInitialized) {
      try {
        MicroModal.init({
          openTrigger: 'data-micromodal-trigger',
          closeTrigger: 'data-micromodal-close',
          onShow: (modalEl) => {
            modalEl.dispatchEvent(new CustomEvent("open"));
            EventBus.emit(`open.modal`, modalEl.id);
          },
          onClose: (modalEl) => {
            modalEl.dispatchEvent(new CustomEvent("close"));
            EventBus.emit(`close.modal`, modalEl.id);
          }
        });

        // Patch MicroModal.show/close to dispatch events when called manually
        
        const originalShow = MicroModal.show;
        MicroModal.show = function (modalId, config = {}) {
          const el = document.getElementById(modalId);
          const result = originalShow.call(this, modalId, config);
          if (el) {
            el.dispatchEvent(new CustomEvent("open"));
            EventBus.emit(`open.modal`, modalId);
          }
          return result;
        };

        const originalClose = MicroModal.close;
        MicroModal.close = function (modalId) {
          const el = document.getElementById(modalId);
          const result = originalClose.call(this, modalId);
          if (el) {
            el.dispatchEvent(new CustomEvent("close"));
            EventBus.emit(`close.modal`, modalId);
          }
          return result;
        };

        window.__micromodalInitialized = true;
      } catch (err) {
        console.error(`MicroModal.init() failed`, err);
      }
    }
  }
};
